import React from "react"

import styles from "./index.module.scss"

export type UserFooterProps = {
  title: string
  onClickOpenDrawer: () => void
}

const UserFooter: React.FC<UserFooterProps> = ({
  title,
  onClickOpenDrawer,
}) => {
  return (
    <div className={styles.footer}>
      <div className={styles.footerInner}>
        <button
          className={`${styles.icon} ${styles.drawer}`}
          onClick={onClickOpenDrawer}
        >
          <i className="fas fa-ellipsis-h"></i>
        </button>
        <div className={styles.title}>{title}</div>
      </div>
    </div>
  )
}

export default UserFooter
